import { BankTransactionsEnabledAtEligibilityDTO } from '@reposit/api-client';

export interface BankTransactionsEnabledAtEligibilityState {
  isLoading: boolean;
  eligibility?: BankTransactionsEnabledAtEligibilityDTO;
}

/** Returns why the earliest bank transfer import date cannot be edited, or undefined when it can. */
export const getBankTransactionsEnabledAtDisabledReason = ({
  isLoading,
  eligibility,
}: BankTransactionsEnabledAtEligibilityState): string | undefined => {
  if (isLoading) {
    return 'Checking whether the earliest bank transfer import date can be set.';
  }

  if (!eligibility) {
    return 'Unable to check whether the earliest bank transfer import date can be set.';
  }

  const { orderIdsWithoutAutomaticHandling } = eligibility;
  if (orderIdsWithoutAutomaticHandling.length) {
    const orders = orderIdsWithoutAutomaticHandling.join(', ');
    const verb = orderIdsWithoutAutomaticHandling.length === 1 ? 'does' : 'do';
    return `${orders} ${verb} not have automatic refund and dispute handling.`;
  }

  return undefined;
};
